import * as React from 'react';
import { Link } from 'react-router-dom';
import { BackArrow } from '../../assets/icons';
import { FundTypes, ToolState } from '../../models';
import toDisplay from '../../lib/numbers/formatToDisplay';
import { i18n } from '../../i18n';

const fundCategory = {
  [FundTypes.CapitalUnconstrained]: 'Capital',
  [FundTypes.CapitalBalanced]: 'Capital',
  [FundTypes.CapitalConservative]: 'Capital',
  [FundTypes.DigitalUnconstrained]: 'Digital',
  [FundTypes.DigitalBalanced]: 'Digital',
  [FundTypes.DigitalConservative]: 'Digital',
};

const fundRiskProfile = {
  [FundTypes.CapitalUnconstrained]: 'Unconstrained',
  [FundTypes.CapitalBalanced]: 'Balanced',
  [FundTypes.CapitalConservative]: 'Conservative',
  [FundTypes.DigitalUnconstrained]: 'Unconstrained',
  [FundTypes.DigitalBalanced]: 'Balanced',
  [FundTypes.DigitalConservative]: 'Conservative'
};

export default (props: ToolState) => (
  <div className='summary-wrap'>
    <div className='summary-header'>
      <Link
        className='button back-button'
        to={{pathname: '/'}}
      >
        <BackArrow /> {i18n.t('tool.summary.back_button_text')}
      </Link>
      <h1 className='title-underline'>{i18n.t('tool.summary.heading')}</h1>
    </div>

    <div className='summary-body'>
      <div className='summary'>
        <div className='summary-details'>
          { props.digitalFund &&
            <div className='detail'>
              <h3>{100 - props.allocation}%</h3>
              <h6>{i18n.t(`tool.inv_choices.${fundRiskProfile[props.digitalFund].toLowerCase()}`)}</h6>
              <p>{i18n.t(`tool.inv_choices.${fundCategory[props.digitalFund].toLowerCase()}`)}</p>
            </div>
          }
          { props.capitalFund &&
            <div className='detail'>
              <h3>{props.allocation}%</h3>
              <h6>{i18n.t(`tool.inv_choices.${fundRiskProfile[props.capitalFund].toLowerCase()}`)}</h6>
              <p>{i18n.t(`tool.inv_choices.${fundCategory[props.capitalFund].toLowerCase()}`)}</p>
            </div>
          }
          <div className='detail'>
            <h3>{toDisplay(props.lumpSum)}</h3>
            <p>{i18n.t('tool.inv_amount.lump_sum')}</p>
          </div>
          <div className='detail'>
            <h3>{toDisplay(props.monthlyContribution)}</h3>
            <p>{i18n.t('tool.inv_amount.monthly_payment')}</p>
          </div>
        </div>
        <div className='summary-total'>
          <h1>{toDisplay(props.mediumCaseOutcome)}</h1>
          <h6>{i18n.t('tool.summary.duration_years', {duration: props.duration})}</h6>
        </div>
        <Link className='button primary-button' to={{pathname: '/next-steps'}}>{i18n.t('tool.summary.done_button_text')}</Link>
      </div>
    </div>
  </div>
);
